export const rating = {
  topLikes: "top_likes",
  lowLikes: "low_likes",
};
